import tippy from "tippy.js";
import barba from "@barba/core";

(($) => {
	const initOpeningHours = () => {
		const openingHours = () => {
			$.ajax({
				type: "GET",
				dataType: "json",
				url: wkScriptVars.ajax_url,
				data: {
					action: "openingHoursCache",
				},
				success(data) {
					$(".footer__opening-hours-string").html(data.openingHours);

					const footerTooltips =
						document.querySelectorAll(".footer__tooltip");

					footerTooltips.forEach((footerTooltip) => {
						tippy(footerTooltip, {
							content: data.openingHoursTippy,
							allowHTML: true,
							placement: "top",
							trigger: "click",
							offset: [0, 18],
							theme: "yellow",
						});
					});

					$(".contact-block__opening-hours-wrapper").html(
						data.openingHoursTippy
					);
				},
			});
		};
		openingHours();
	};

	barba.hooks.beforeEnter(initOpeningHours);
	document.addEventListener("DOMContentLoaded", initOpeningHours);
})(window.jQuery);
